import React from 'react';
import {StatContent} from "../../../models/SiteContent";

// One icon per slot, in the order the design places them around the panel.
const BADGE_ICONS = [
    (
        <svg viewBox="0 0 24 24" width="19" height="19" stroke="currentColor" fill="none"
             strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path
                d="M12 2.5l2.3 1.5 2.8-.1.9 2.6 2.3 1.6-.9 2.7.9 2.7-2.3 1.6-.9 2.6-2.8-.1L12 21.5l-2.3-1.5-2.8.1-.9-2.6-2.3-1.6.9-2.7-.9-2.7 2.3-1.6.9-2.6 2.8.1z"/>
            <path d="M9 12l2 2 4-4.5"/>
        </svg>
    ),
    (
        <svg viewBox="0 0 24 24" width="19" height="19" stroke="currentColor" fill="none"
             strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 17l6-6 4 4 6-9"/>
            <path d="M20 6h-5M20 6v5"/>
        </svg>
    ),
    (
        <svg viewBox="0 0 24 24" width="19" height="19" stroke="currentColor" fill="none"
             strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 3h8l4 4v14H6z"/>
            <path d="M14 3v4h4"/>
            <path d="M9 12h6M9 16h4"/>
        </svg>
    ),
];

const BADGE_SLOTS = ['one', 'two', 'three'];

interface HeroStatBadgesProps {
    stats: StatContent[];
}

// These carry the only real information in the demo column, so they are
// SIBLINGS of the aria-hidden card (never children of it) and each one is a
// focusable button that expands on :hover and :focus-visible.
const HeroStatBadges: React.FC<HeroStatBadgesProps> = ({stats}) => (
    <>
        {stats.slice(0, 3).map((stat, index) => (
            <button
                key={BADGE_SLOTS[index]}
                type="button"
                className={`lnk-hero__badge lnk-hero__badge--${BADGE_SLOTS[index]}`}
                aria-label={`${stat.value} ${stat.label}`}
            >
                <span className="lnk-hero__badge-icon" aria-hidden="true">
                    {BADGE_ICONS[index]}
                </span>
                <span className="lnk-hero__badge-text" aria-hidden="true">
                    {stat.value} {stat.label}
                </span>
            </button>
        ))}
    </>
);

export default HeroStatBadges;
